window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.brandJackpotRepo = function () {
    var url = 'api/casinobrandjackpot';

    var get = function (brandID) {

        return fetch(url + casino.repos.base.serializeGetParams({
            brandID: brandID
        }), {
            credentials: repos.base.credentials
        })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        get: get
    }
}();